// src/config/checkout.js
// Current Stripe-hosted, one-time checkout copy. Legacy keys remain admin-compatible.
import { PURCHASE_NOTE } from './paymentCopy.js';

export const DEFAULT_CHECKOUT = {
    pageTagline: 'Checkout',
    pageTitle: 'Secure Checkout',
    contactSectionTitle: 'Contact',
    billingSectionTitle: 'Order Summary',
    paymentSectionTitle: 'Payment',
    stripeNote: 'Card payments are securely processed by Stripe. Available wallets are shown at checkout.',
    billedAnnuallyNote: PURCHASE_NOTE,
    payButtonPrefix: 'Pay',
    payButtonSuffix: '',
    successTitle: 'Check your library',
    successMessage: 'Your packs unlock after payment is confirmed. Access lasts 12 months, with no automatic renewal.'
};

// Only migrate exact obsolete defaults; preserve Danielle's custom wording.
const legacy = {
    pageTitle: 'Secure Checkout · Annual Subscription',
    stripeNote: 'This is a demo checkout. No real card will be handled until Stripe is configured during deployment.',
    billedAnnuallyNote: 'Billed annually. You may cancel before renewal to avoid being charged.',
    payButtonPrefix: 'Subscribe', payButtonSuffix: '/yr',
    successTitle: 'Subscription Activated',
    successMessage: 'Your study packs have been unlocked. Your subscription will renew in 12 months — cancel anytime from your account.'
};
export function resolveCheckoutCopy(saved = {}) {
    const copy = { ...DEFAULT_CHECKOUT, ...(saved || {}) };
    for (const [key, value] of Object.entries(legacy)) {
        if (copy[key] === value) copy[key] = DEFAULT_CHECKOUT[key];
    }
    return copy;
}
